/**
 * Authentication hook for user context
 */

import { useQuery } from '@tanstack/react-query'
import { authApi } from '../services/api'
import type { User } from '../types'

export const useAuth = () => {
  const {
    data: user,
    isLoading,
    error,
    isError,
    refetch,
  } = useQuery<User, Error>({
    queryKey: ['currentUser'],
    queryFn: authApi.getCurrentUser,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })

  return {
    user,
    isAuthenticated: !!user,
    isLoading: isLoading && !isError, // Don't show loading if there's an error
    error,
    login: authApi.login,
    logout: authApi.logout,
    refetch,
  }
}
